import React from "react";
import videojs from "video.js";
import "../../../node_modules/video.js/dist/video-js.min.css";
import "../../../node_modules/@silvermine/videojs-quality-selector/dist/css/quality-selector.css";
import "@videojs/themes/dist/fantasy/index.css";
import "videojs-hotkeys"
require("@silvermine/videojs-quality-selector")(videojs);

export default class VideoPlayer extends React.Component {
  
  componentDidMount() {
    // instantiate Video.js
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      this.hotkeys({
        volumeStep: 0.1,
        seekStep: 10,
        enableModifiersForNumbers: false
      });
    });
  }

  componentDidUpdate() {
    const time = this.player.currentTime();
    this.player.src(this.props.sources);
    this.player.load();
    this.player.currentTime(time);
    this.player.play();
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
      <>
      <div
        data-vjs-player
        style={{
          width: this.props.width ? this.props.width : "100%",
          height: this.props.height ? this.props.height : "100%",
        }}
      >
        <video
          ref={(node) => (this.videoNode = node)}
          className="video-js vjs-big-play-centered vjs-theme-fantasy"
          width="100%"
          height="100%"
        ></video>
      </div>
      </>
    );
  }
}
